<template>
  <section class="h-full">
    <perview-file v-if="isFilePriview" v-bind:file="filePriviewData" @closePopup="closePopup"></perview-file>
    <TopAppBar
        :leftBtnMethod="leftBtnMethod"
        :leftBtnMode="leftBtnMode"
        :rightBtnMethod="rightBtnMethod"
        :rightBtnMode="rightBtnMode"
        :title="title"
        :hideCategory="false"
        staticMode="true"
    >
    </TopAppBar>
    <div class="d-flex flex-column h-full">
      <TopAppBarDrawer></TopAppBarDrawer>
      <main v-if="detail" ref="boardViewContainer" class="main-wrapper flex-grow-1 with-footer bg-documentGray">
        <div class="d-flex align-items-center fix-header-title bg-white">
          <div class="t-headline13 t-color-headlineBlack pda-14 t-center  flex-grow-1 ">
            <div class="font-m">{{ headerName }}</div>
          </div>
          <div class="right-button">
            <div
                class="pdl-16 mgr-16 mdc-menu-anchor menu-container cursor-pointer more-btn-parent-div position-relative header-toggle">
              <i v-if="(detail && (!detail.owner || (selectedChild && selectedChild.modify === true) ||  (selectedChild && selectedChild.remove === true) ))"
                 class="material-icons mdc-icon-button t-headline6 js--dropdown-toggle"
                 tabindex="0" @click="handleModal(detail.id)" @keypress="handleModal(detail.id)">more_horiz</i>
              <!-- 게시글 부분 -->
              <UserDetailActionModal
                  v-if="isOpenModal && detail.id === selectedId"
                  :type="'BOARD'"
                  :data="detail" 
                  :selectedChild="selectedChild"
                  @report="askForReport" 
                  @block="handleBlock" 
                  @edit="askForModify" 
                  @delete="askForDelete"
                  :className="'action-modal'"
              />
            </div>
          </div>
        </div>
        <div class="divider"></div>

        <div ref="boardViewContainer" class="shadow2 fix-header-title-content bg-white">
          <div class="container container--narrow pdt-30 pdb-20">
            <div class="">
              <div class="d-flex">
                <UserImgProfile :allData="detail" :data="detail.auditor.register" :className="'mgr-0'" />

                <div class="flex-grow-1 pdl-16">
                  <div class="justify-content-between">
                    <div class="t-body1 mgb-1 font-r t-line-h-24" :class="{'t-color-bodyGrayB': detail.isBlocked}">{{
                        detail.auditor ? $t('3437', {
                          first: detail.auditor.register.name.first,
                          last: detail.auditor.register.name.last
                        }) : ''
                      }}
                    </div>
                    <div class="t-body3  t-color-bodyGrayA font-r mgr-8 mgt-4 t-line-h-20" :class="{'t-color-bodyGrayB': detail.isBlocked}">
                      {{ $moment(detail.auditor ? detail.auditor.register.time : '').format("L") }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="t-body1 font-r mgt-16 l-spacing48 t-line-h-25" :class="{'t-color-bodyGrayB': detail.isBlocked}">
                {{ detail.isBlocked ? $t("3814") : detail.contents.subject }}
              </div>

              <div v-if="!detail.isBlocked && detail.contents.type"
                   class="ql-container"
                   id="summernote"
                   v-html="detail.contents.body"></div>
              <div v-else-if="!detail.isBlocked" class="t-body6 font-r t-color-bodyGrayA mgt-16 mgb-16 l-spacing45 t-line-h-25 t-preline"
                   v-html="detail.contents.body">
              </div>

              <div v-for="(img, i) in detail.contents.files" :key="i"
                   class="mgt-8 card-image-single position-relative cursor-pointer" tabindex="0">
                <div v-show="img.saveType.value === mediaTypeConstants.MEDIA_SAVE_TYPE.value">
                  <img v-if="!detail.isBlocked && getType(img.contentType) === 'image'" :alt="img.originalName" :src="img.resourceUri"
                     class="b-radius4 view-image">	
	                  <VideoComponent
			                  id="video1"
			                  v-else-if="!detail.isBlocked"
			                  :record="img"
			                  :videoSize="'large'"
			                  :fullSizeVideo="true">
	                  </VideoComponent>
                </div>
              </div>

              <div class="d-flex mgb-12 flex-wrap" v-if="!detail.isBlocked">
                <div
                    v-for="(tag, i) in detail.tags" :key="i"
                    class="pdl-4 pdr-4 pdt-2 pdb-2 b-radius2 mgt-4 mgr-4 t-helper font-r t-color-contentBlue bg-contentBlueInactive">
                  #{{ tag.name }}
                </div>
              </div>
              <div class=" mgt-8 mgb-16"></div>

              <div v-if="detail && !detail.isBlocked && detail.contents.files !== null" class="community-search-list mgt-24">
                <div v-for="(file, i) in detail.contents.files" :key="i">
                  <div v-show="file.saveType.value === mediaTypeConstants.ATTACHED_SAVE_TYPE.value">
                  <div class="pdl-16 pdr-16 pdt-7 pdb-6 bg-documentGray mgb-8 b-radius4">
                    <div class="d-flex align-items-center justify-content-between search-list ">
                      <div class="d-flex align-items-center flex-grow-1">
                        <i class="material-icons t-color-secondaryBtnText pdr-8 t-line-h-29 font-20">attach_file</i>
                        <a class="t-body3 font-r t-color-signBlue"
                           href="javascript:void(0)"
                           tabindex="0" @click="downloadFile(file.resourceUri, file.originalName, file.contentType)" @keypress="downloadFile(file.resourceUri, file.originalName, file.contentType)">{{
                            file.originalName
                          }}</a>
                      </div>
                      <div  class="d-flex align-items-center">
                        <i class="material-icons t-color-iconInactive cursor-pointer font-20" @click="downloadFile(file.resourceUri, file.originalName, file.contentType)" @keypress="downloadFile(file.resourceUri, file.originalName, file.contentType)">download</i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="divider" v-if="!detail.isBlocked"></div>

              <div class="d-flex justify-content-between mgt-16" v-if="!detail.isBlocked">
                <div class="t-helper t-color-bodyGrayB font-r">
                  {{ $t("3130", {str: detail.commentCount > 0 ? detail.commentCount : '0'}) }}
                </div>
                <div class="t-helper t-color-bodyGrayB font-r">
                  {{ $t("3131", {str: detail.viewCount ? detail.viewCount : '0'}) }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="comments.length <= 0" class="bg-documentGray mgt-2 pdb-50">
          <div class="container container--narrow pdt-50 pdb-50">
            <div class="t-body3 t-color-bodyGrayB font-r l-spacing45 t-line-h-25 t-center">
              {{ $t('3132') }}<br>{{ $t('3133') }}
            </div>
          </div>
        </div>

        <div id="scrollToBottom"
             ref="commentContainer"
             :style="form.images.length > 0 ? 'padding-bottom: 158px':'padding-bottom: 24px'" class="bg-documentGray mgt-2">
          <div class="container container--narrow pdt-16 pdb-30">
            <div v-for="comment in comments" :key="comment.id" class="d-flex mgb-16">
              <UserImgProfile v-if="comment.auditor" :allData="comment" :data="comment.auditor.register" :className="'mgr-0 mgt-16'" />

              <div class="d-flex flex-row-reverse w-full">
                <div
                    v-if="comment.status.value === commentStatusConstants.post"
                    class="pdl-16 more-btn-parent-div mdc-menu-anchor menu-container cursor-pointer header-toggle mgr--18 2">
                  <i v-if="!comment.owner || (selectedChild && selectedChild.modify === true) ||  (selectedChild && selectedChild.remove === true)"
                   class="material-icons mdc-icon-button t-headline6 js--dropdown-toggle t-color-iconInactive"
                   tabindex="0"
                   @click="handleModal(comment.id)" @keypress="handleModal(comment.id)">more_horiz</i>
                  
                   <!-- 댓글 부분 -->
                  <UserDetailActionModal
                    v-if="isOpenModal && comment.id === selectedId"
                    :type="'COMMENT'"
                    :data="comment" 
                    :selectedChild="selectedChild"
                    @report="reportComment" 
                    @block="handleBlock" 
                    @edit="editCommentSet" 
                    @delete="deleteComment"  
                    :className="'action-modal'"
                  />
                </div>

                <div class="flex-grow-1  mgt-16">
                  <div class="d-flex justify-content-between pdl-16">
                    <div class="t-body1 mgb-1 font-r mgb-4" :class="{'t-color-bodyGrayB': comment.isBlocked}">{{
                        comment && comment.auditor && comment.auditor.register && comment.auditor.register.name ? $t('3437', {
                          first: comment.auditor.register.name.first,
                          last: comment.auditor.register.name.last
                        }) : ''
                      }}
                    </div>
                  </div>
                  <div v-show="comment.status.value === commentStatusConstants.post" class="t-body3 font-r t-color-bodyGrayA  pdl-16" :class="{'t-color-bodyGrayB': comment.isBlocked}">
                    {{ $moment(comment.auditor && comment.auditor.register && comment.auditor.register.time).format("L") }}
                  </div>
                  <div v-if="comment.status.value === commentStatusConstants.removed" class="t-body6 font-r t-color-bodyGrayA mgt-16 l-spacing45 t-line-h-25 dkksj pdl-16">
                    <p class="date">{{ $t('3749') }}</p>
                  </div>
                  <div v-else-if="comment.status.value === commentStatusConstants.hided" class="t-body6 font-r t-color-bodyGrayA mgt-16 l-spacing45 t-line-h-25 dkksj pdl-16">
                    <p class="date">{{ $t('3750') }}</p>
                  </div>
                  <div v-else-if="comment.status.value === commentStatusConstants.post" class="t-body6 font-r t-color-bodyGrayA mgt-16 l-spacing45 t-line-h-25 dkksj pdl-16 t-preline" :class="{'t-color-bodyGrayB': comment.isBlocked}"
                       v-html="comment.isBlocked ? $t('3814') : comment.contents">
                  </div>
                  <show-slider v-if="!comment.isBlocked" :fileData="false" :imageArray="comment" @fileDisplay="fileDisply"></show-slider>
                  <button v-if="!comment.isBlocked && selectedChild && selectedChild.register === true && comment.status.value === commentStatusConstants.post" class="mdc-button mgl-8"
                          tabindex="0" @click="toggleReply(comment.id,comment.auditor.register.name.fullName)" >
                    <span class="mdc-button__ripple"></span>

                    <span class="mdc-button__label t-body3 font-r t-color-iconInactive">
											{{ $t('1444') }}
										</span>
                  </button>
                  <input id="replyCommentId" type="hidden"/>
                  <div :id="`commentInput_${comment.id}`" class="d-grid flex-column d-none">
                  </div>
                  <!-- reply section -->
                  <div v-for="reply in comment.children" :key="reply.id" class="d-flex mgb-16 reply-box mgt-8">
                    <UserImgProfile v-if="reply.auditor" :allData="reply" :data="reply.auditor.register" :className="'mgr-0 mgt-16'" size="s"  />

                    <div class="d-flex flex-row-reverse w-full">
                      <div
                          class="pdl-16  more-btn-parent-div mdc-menu-anchor menu-container cursor-pointer header-toggle mgr--18 3">
                        <i v-if="!comment.owner || (selectedChild && selectedChild.modify === true) ||  (selectedChild && selectedChild.remove === true) "
                           class="material-icons mdc-icon-button t-headline6 js--dropdown-toggle t-color-iconInactive"
                           tabindex="0"
                           @click="handleModal(reply.id)" @keypress="handleModal(reply.id)">more_horiz</i>

                        <!-- 대댓글 부분 -->
                        <UserDetailActionModal
                          v-if="isOpenModal && reply.id === selectedId"
                          :type="'REPLY'"
                          :data="reply" 
                          :parentData="comment"
                          :selectedChild="selectedChild"
                          @report="reportComment" 
                          @block="handleBlock" 
                          @edit="editReplySet" 
                          @delete="deleteComment"  
                          :className="'action-modal'"
                        />
                      </div>
                      <div class="flex-grow-1  mgt-16">
                        <div class="d-flex justify-content-between pdl-16">
                          <div class="t-body1 mgb-1 font-r mgb-4" :class="{'t-color-bodyGrayB': reply.isBlocked}">{{
                              reply.auditor.register.name ? $t('3437', {
                                first: reply.auditor.register.name.first,
                                last: reply.auditor.register.name.last
                              }) : ''
                            }}
                          </div>
                        </div>
                        <div v-show="reply.status.value === commentStatusConstants.post" class="t-body3 font-r t-color-bodyGrayA  pdl-16" :class="{'t-color-bodyGrayB': reply.isBlocked}">
                          {{ $moment(reply.auditor.register.time).format("L") }}
                        </div>
                        <div v-if="reply.status.value === commentStatusConstants.removed" class="t-body6 font-r t-color-bodyGrayA mgt-16 l-spacing45 t-line-h-25  pdl-16">
                          <p class="date">{{ $t('3749') }}</p>
                        </div>
                        <div v-else-if="reply.status.value === commentStatusConstants.hided" class="t-body6 font-r t-color-bodyGrayA mgt-16 l-spacing45 t-line-h-25  pdl-16">
                          <p class="date">{{ $t('3750') }}</p>
                        </div>
                        <div v-else-if="reply.status.value === commentStatusConstants.post"
                             class="t-body6 font-r t-color-bodyGrayA mgt-16 l-spacing45 t-line-h-25  pdl-16 t-preline" :class="{'t-color-bodyGrayB': reply.isBlocked}"
                             v-html="reply.isBlocked ? $t('3814') : reply.contents">
                        </div>
                        <show-slider v-if="!reply.isBlocked" :fileData="true" :imageArray="reply" @fileDisplay="fileDisply"></show-slider>
                      </div>
                    </div>
                  </div>
                  <!-- end of reply section -->
                </div>
              </div>
            </div>
            <infinite-loading :identifier="infiniteId" spinner="spiral" @infinite="getComments">
              <div slot="no-more" class="t-color-white d-none"></div>
              <div slot="no-results" class="t-color-white d-none"></div>
            </infinite-loading>
          </div>
        </div>
        <div class="setHeightBlank"></div>
        <div class="toggle-menu-scrim d-none" @click="menuActivate" @keypress="menuActivate"></div>
      </main>

      <div v-if="selectedChild && selectedChild.register === true && !detail.isBlocked" class="textBlock footer bg-white bottomStack board-footer">
        <div class="divider"></div>
        <div class="container container--narrow pdb-0">

          <div class="d-flex align-items-center justify-content-between pdt-14 pdb-14">
            <div class="d-flex flex-grow-1 position-relative">
              <div v-if="userName" class="t-body3 t-color-linkBlue font-r bg-linkBg mention-text-area mgr-8 mgt-1 position-absolute">
                @{{ userName }}<span class="cursor-pointer t-color-iconInactive pdl-8 pdr-4 mgr-8 mgl-unset"
                                     tabindex="0" @click="toggleReply" @keypress="toggleReply">x</span></div>
              <textarea
                  id="comment_textarea"
                  v-model="form.contents"
                  :class="{'commentInvaliderror' : commentValid}"
                  :placeholder="$t('1445')"
                  class="mdc-text-field__input t-body6 font-r l-spacing42 t-color-headlineBlack t-line-h-25 t-justify"
                  maxlength="400"
                  rows="1"
                  tabindex="0"
                  @click="setActive"
                  @keypress="setActive"
                  @keyup="resizeIt($event.target.value)">
            </textarea>
            </div>
          </div>
          <div v-if="form.images.length > 0" class="d-flex scroll-x">
            <div v-for="(img, i) in form.images" :key="i"
                 class="attached-image-preview-126 mgt-16 mgr-24 position-relative attachement-preview">
              <img v-if="getType(img.contentType) === 'image'" :alt="img.originalName" :src="img.resourceUri"/>
                <VideoComponent
                    v-else
                    :record="img"
                    :videoSize="'small'"
                    :fullSizeVideo="false">
                </VideoComponent>
              <span class="remove-img remove-image-new position-absolute t-color-white"
                    tabindex="0" @click="form.images.splice(i, 1)" @keypress="form.images.splice(i, 1)">
									<i class="material-icons t-body1">close</i>
								</span>
            </div>
          </div>
          <photo-album :form="form" class="" @removeImage="removeImage" @toggleDocument="toggleDocument"
                       @uploadFile="uploadFile">
            <button
                slot="submitButton"
                :class="(form.contents !== null && !isContentsEmpty) || !isFormImagesEmpty ? 'sendMessageBtnActive' : 'sendMessageBtn'"
                class="mdc-icon-button t-color-white align-items-center justify-content-between" tabindex="0"
                @click="submitComment" @keypress="submitComment">
              <i class="material-icons min-w-26 min-h-26">arrow_upward</i></button>
          </photo-album>
        </div>
      </div>
    </div>
    <!-- <div class="backlayer"></div> -->
    <div v-if="isOpenModal" @click="closeModal" @keypress="closeModal" class="modal-background" />
  </section>
</template>

<script>
import {MDCMenu} from '@material/menu';
import boardApi from '@/api/boardApi.js'
import "video.js/dist/video-js.css";
import {videoPlayer} from "vue-video-player";

import snackMessage from "@/plugins/snackMessage";
import TopAppBar from '@/components/TopAppBar.vue'
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import {fileMixin} from "@/mixins/file";
import {userMixin} from "@/mixins/user";
import {commentStatusConstants} from "@/utils/enum/CommentStatusConstants";

import PerviewFile from "./PerviewFile";
import ShowSlider from "./ShowSlider";
import axios from 'axios'
import InfiniteLoading from "vue-infinite-loading";
import {mediaTypeConstants} from "@/utils/enum/MediaTypeConstants";
import VideoComponent from "@/components/common/VideoComponent.vue";
import UserDetailActionModal from '../common/modal/UserDetailActionModal.vue';

export default {
  data() {
    return {
      menuBar: null,
      headerName: null,
      userAuthData: null,
      detail: null,
      isComment: true,
      comments: [],
      coomentActiveButton: false,
      commentValid: false,
      commentEdit: false,
      commentEditId: null,
      selectedChild: null,
      mamberData: [],
      form: {
        contents: null,
        images: [],
      },
      replyImg: [],
      currentPage: 1,
      totalPages: 1,
      infiniteId: +new Date(),
      b: true,
      userName: '',
      evtReply: {},
      commentBottom: true,
      isFilePriview: false,
      filePriviewData: null,
      firstCharOfNames: localStorage.getItem('firstChar'),
      bgColorOfName: localStorage.getItem('bgColors'),
      imageSize: true,
      commentStatusConstants: commentStatusConstants,
      mediaTypeConstants: mediaTypeConstants,
      isOpenModal: false,
      selectedId: null,
    }
  },

  mixins: [topAppBarMixin, fileMixin, userMixin],

  components: {
    videoPlayer,
    TopAppBar,
    TopAppBarDrawer,
    PerviewFile,
    ShowSlider,
    VideoComponent,
    'photo-album': () => import('@/components/common/PhotoAlbum'),
    InfiniteLoading,
    UserDetailActionModal,
    UserImgProfile: () => import("@/components/common/checkUser/UserImgProfile.vue"),
  },

  watch: {
    $route(to, from) {
      this.userAuth();
    }
  },

  computed: {
    isFormImagesEmpty() {
      return this.form.images.length === 0;
    },

    isContentsEmpty() {
      return this.form.contents === null || /^\s*$/.test(this.form.contents);
    }
  },

  mounted() {
    let boardName = this.$route.query.boardName.replace('-', '&');
    this.headerName = boardName;

    this.userAuth();
    this.getDetail();
  },

  methods: {
    menuActivate() {
      const toggleBackground = document.querySelector('.toggle-menu-scrim')

      let openedMenubar = document.querySelector(".mdc-menu-surface--open");
      if (openedMenubar) {
        openedMenubar.classList.remove("mdc-menu-surface--open");
      }
      toggleBackground.classList.add('d-none')
    },

    firstCharOfMemberName(name) {
      if(!name) {
        return;
      }
      if (name.first) {
        let fullName = this.$t('3437', {first: name.first, last: name.last});
        return fullName.charAt(0);
      } else {
        let fullName = name.fullName;
        return fullName.charAt(1);
      }
    },

    userAuth() {
      //let responseData = null
      boardApi.boardAuth(this.$route.params).then((response) => {
        this.userAuthData = response.data.data;
        boardApi.fetchMember().then(response => {
          this.mamberData = response.data.data;
          let myId = this.mamberData.responsibilityId
          if (this.userAuthData.authType.value === 'STORE') {
            this.selectedChild = this.userAuthData.authPermission[0];
          } else {
            this.selectedChild = this.userAuthData.authPermission.find(child => child.partId == myId)
          }
        }).catch(err => {
          $state.error();
        });
      }).catch((err) => {
        this.$error({content: err.errMsg}).then(() => {
        });
      });
    },

    askForReport(data) {
      if (!this.detail.report) {
        this.$router.push({
          name: "ReasonChoice",
          query: { ...this.$route.query, type: "BOARD" },
          params: { data }
        })
      } else {
        this.menuActivate();
        snackMessage(this.$t("3808"));
      }
    },

    //Alert box delete
    askForDelete() {
      this.$confirm({
        content: this.$t("1877"), // '삭제하시겠습니까?'
        accept: this.$t("1879"), // 확인
        cancel: this.$t("1878"), // 취소
      }).then(() => {
        this.deletePost();
      }).catch(() => {
      })
      this.closeModal();
    },

    //Generate Report by loggedIn user
    reportPost() {
      this.$showLoading();
      boardApi.reportPost(this.$route.params).then((response) => {
        this.$hideLoading();
      }).catch((err) => {
        this.$hideLoading();
        this.$error({content: err.errMsg}).then(() => {
        });
      });
      this.closeModal();
    },

    //Delete post by loggedIn user
    deletePost() {
      this.$showLoading();
      boardApi.deletePost(this.$route.params).then((response) => {

        this.$hideLoading();
        this.goToPrevious()
        //this.$router.push('/socialLearning?board='+this.boardId+'&boardName='+encodeURI(this.boardName))
      }).catch((err) => {
        this.$hideLoading();
        this.$error({content: err.errMsg}).then(() => {
        });
      });
      this.closeModal();
    },

    getDetail() {
      this.$showLoading();
      boardApi.boardDetails(this.$route.params).then((response) => {
        this.detail = response.data.data;

        this.$hideLoading();
      }).catch((err) => {
        this.$hideLoading();
        this.$error({content: err.errMsg}).then(() => {
        });
      });
    },

    getListComments() {
      let params = {
        size: this.currentPage * 10,
      };
      boardApi.listComments(this.$route.params, params).then((response) => {
        let responseData = response.data.data;
        this.comments = responseData.content;
      });
    },

    // Comment list
    getComments($state) {
      let responseData = null;
      let params = this.setParams();
      if (this.totalPages >= this.currentPage) {
      boardApi.listComments(this.$route.params, params).then((response) => {
        responseData = response.data.data;
        this.comments = this.comments.concat(responseData.content);
        if (responseData.content.length) {
          $state.loaded();
        } else {
          $state.complete();
        }
        this.currentPage++;
        this.totalPages = responseData.totalPages;
      }).catch((err) => {});
      } else {
        $state.complete()
      }
    },

    setParams() {
      let params = {
        page: this.currentPage,
        size: 10,
      };
      return params;
    },

    // Preview of image and video
    fileDisply(data) {
      this.isFilePriview = true;
      this.filePriviewData = data;
    },

    closePopup() {
      this.isFilePriview = false;
    },

    getWHieght() {
      return $(window).width();
    },

    resetVideo() {
      this.form.images = Array();
    },

    resizeIt(str) {
      let elmnt = document.getElementById("comment_textarea");
      elmnt.style.height = 0;
      let scHeight = elmnt.scrollHeight;
      elmnt.style.height = scHeight + "px";

      if (document.querySelector('.mention-text-area')) {
        let replyedBy = document.querySelector('.mention-text-area').clientWidth;
        document.querySelector("#comment_textarea").style.textIndent = replyedBy + 8 + 'px'
      } else {
        document.querySelector("#comment_textarea").style.textIndent = '0px'
      }

      let h = document.querySelector('.textBlock').scrollHeight;
      if (document.querySelector('.view')) {
        document.querySelector('.view').style.paddingBottom = h + 'px';
      }
    },

    setActive() {
      this.coomentActiveButton = true;
    },

    // Submit Comment,
    submitComment() {
      this.$showLoading();
      if (this.isContentsEmpty && this.isFormImagesEmpty) {
        this.$hideLoading();
        return this.commentValid = true;
      } else {
        if (this.b === true) {
          if ((this.form.contents && this.form.contents.length > 0) || (this.form && this.form.images.length > 0)) {
            this.commentValid = false;
            this.userAuth();
            if (this.commentEdit) {
              boardApi.commentEdit(this.$route.params, this.form, this.commentEditId).then((resp) => {
                this.$hideLoading();
                this.getListComments();
                this.resetCommentForm();
                this.commentEdit = false;
              }).catch((err) => {
                this.$error({content: err.errMsg}).then(() => {
                });
              });
            } else {
              if (this.userAuthData.userCommToDayAuth) {
                boardApi.commentPost(this.$route.params, this.form).then((resp) => {
                  this.$hideLoading();
                  this.getListComments();
                  this.resetCommentForm();
                  this.userAuth();
                  this.$nextTick(() => {
                    window.scrollTo(0, document.body.scrollHeight);
                  })
                }).catch((err) => {
                });
              } else {
                this.$hideLoading();
                snackMessage(this.$t("3064"));
              }
            }
          } else {
            this.commentValid = true;
          }
        } else {
          let commentId = document.getElementById('replyCommentId').value;
          this.submitReply(commentId)
        }
      }
    },

    // Empty Comment Textarea after submit
    resetCommentForm() {
      this.form = {
        contents: null,
        images: [],
      };
      var elmnt = document.getElementById("comment_textarea");
      var newElement = document.querySelector('.setHeightBlank');
      elmnt.style.height = "unset";
      newElement.style.height = 0 + "px";
      document.querySelector("#comment_textarea").style.textIndent = '0px'
    },

    /**
     * Open menu report, modify and delete
     * @param evt 이벤트
     */
    toggleMore(evt) {
      let field = evt.target.closest(".more-btn-parent-div").querySelector(".more_box");
      field.classList.remove('d-none');
      field.classList.add('z-200');

      const toggleBackground = document.querySelector('.toggle-menu-scrim');
      let openedMenubar = document.querySelector(".mdc-menu-surface--open");

      if (openedMenubar) {
        openedMenubar.classList.remove("mdc-menu-surface--open");
      }

      field.classList.toggle("mdc-menu-surface--open");
      field.classList.toggle('mdc-menu-surface--is-open-below');
      toggleBackground.classList.remove('d-none');
    },

    // 유저 차단
    async handleBlock(item, isBlocked) {
      try {
        await this.blockUser(item, isBlocked);
        this.getDetail();
        this.getListComments();
      } catch (error) {
        console.log("BOARD BLOCK ERROR : ", error);
      } finally {
        this.closeModal();
      }
    },

    reportComment(data) {
      this.menuActivate();
      if (data.report !== true) {
        this.$router.push({
          name: "ReasonChoice",
          query: { ...this.$route.query, type: "COMMENT" },
          params: { data: this.detail, commentData: data }
        })
      } else {
        snackMessage(this.$t("3738"))
      }
    },

    /**
     * 댓글 신고하기 API 호출 메소드
     * @param {String} id 댓글/대댓글 아이디
     */
    callReportComment(id) {
      if (!this.detail.report) {
        this.$router.push({
          name: "ReasonChoice",
          query: { ...this.$route.query, type: "COMMENT" },
          params: { data }
        })
      } else {
        this.menuActivate();
        snackMessage(this.$t("3808"));
      }
    },

    deleteComment(id, pid, evt) {
      // this.toggleMore(evt);
      this.$confirm({
        content: this.$t("1877"),
        accept: this.$t("1879"), // 확인
        cancel: this.$t("1878"), // 취소
      }).then(() => {
        boardApi.deleteComment(this.$route.params, id).then((response) => {
          this.getListComments();
        }).catch(() => {
        });
      });
    },

    editCommentSet(comment, evt) {
      this.commentBottom = true;
      this.userName = '';
      this.replyEditId = '';
      this.replyEdit = false;
      this.form.contents = comment.contents;
      this.form.images = comment.images;
      this.commentEditId = comment.id;
      this.commentEdit = true;
      this.menuActivate();
    },

    // Edit Reply Textarea
    editReplySet(reply, cid, evt, userId) {
      this.commentEditId = '';
      this.commentEdit = false;
      this.commentBottom = false;
      this.form.contents = reply.contents;
      this.form.images = reply.images;
      this.replyEditId = reply.id;
      this.replyEdit = true;
      // this.toggleMore(evt)
      this.toggleReply(cid, userId)
    },

    // Reply button
    toggleReply(commentId, userId) {
      this.commentBottom = false
      this.userName = userId
      this.b = !this.b;
      let comeId = document.getElementById('replyCommentId').value = commentId
      if (comeId && this.b === false) {
        this.userName;
        this.$nextTick(() => {
          this.resizeIt()
        })
      } else {
        this.userName = '';
        document.querySelector("#comment_textarea").style.textIndent = '0px'
      }
      document.getElementById(`commentInput_${commentId}`).classList.toggle("d-none");
    },

    // Submit Reply comment
    submitReply(originId) {
      this.userAuth();
      this.$showLoading();
      if (!this.replyEdit) {
        if (this.userAuthData.userCommToDayAuth) {
          // call API to add reply
          boardApi.postReply(this.$route.params, originId, this.form).then((response) => {
            this.$hideLoading();
            this.getListComments();
            this.resetCommentForm();

            this.toggleReply(originId);
            this.replyImg = [];
            this.userName = '';

          }).catch((err) => {
          });
        } else {
          this.$hideLoading();
          snackMessage(this.$t("3064"));
        }
      } else {
        boardApi.editReply(this.$route.params, this.replyEditId, this.form).then((response) => {
          this.$hideLoading();
          this.getListComments();
          this.resetCommentForm();
          this.replyImg = [];
          this.userName = '';

        }).catch((err) => {
        });
      }
    },

    // modal handle function
    handleModal(id) {
      console.log(id)
      this.isOpenModal = !this.isOpenModal;
      this.selectedId = id;
    },

    // modal close function
    closeModal() {
      this.isOpenModal = false;
      this.selectedId = null;
    },

    askForModify() {
      this.$router.push({
        name: 'BoardModify',
        params: {boardId: this.$route.params.boardId, postId: this.$route.params.postId},
        query: this.$route.query
      })
    },

    goToPrevious() {
      if (this.$route.query && this.$route.query.fromPage == 'main') {
        this.$router.push('/home')
      } else {
        this.$router.push('/board/' + this.$route.params.boardId + '?boardName=' + encodeURI(this.$route.query.boardName) + '&categoryName=' + encodeURI(this.$route.query.categoryName))
      }
    }

  }
}
</script>
<style scoped>
.new_line {
  white-space: pre-wrap;
}

.comment_box {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 999;
  padding: 0px 16px 16px 16px;
  background: var(--DocumentWhite);
  box-sizing: border-box;
  overflow: auto;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5); */
}

html[dir="rtl"] .comment_box {
  right: 0;
}

.comment_box img {
  width: 80px;
  height: 80px;
  object-fit: cover;
}

.remove-image-new {
  top: -16px;
  right: -16px;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background: var(--Iconinactive);
  display: flex;
  justify-content: center;
  align-items: center;
  border: 3px solid var(--DocumentWhite);
  color: var(--DocumentWhite);
  line-height: 0px;

}

html[dir="rtl"] .remove-image-new {
  left: -16px;
}

.commentInvaliderror::-webkit-input-placeholder {
  color: var(--Secondary);
}

.commentInvaliderror:-moz-placeholder { /* Firefox 18- */
  color: var(--Secondary);
}

.commentInvaliderror::-moz-placeholder { /* Firefox 19+ */
  color: var(--Secondary);
}

.commentInvaliderror:-ms-input-placeholder {
  color: var(--Secondary);
}

.commentInvaliderror::placeholder {
  color: var(--Secondary);
}

.commentInvaliderror::placeholder {
  color: var(--Secondary);
}

.comment_box img {
  border-radius: 4px;
}

.replyTextBox {
  border: 1px solid var(--Divider);
  margin-left: -56px;
}

html[dir="rtl"] .replyTextBox {
  margin-right: -56px;
}

.comment_box img {
  border-radius: 4px;
}

.replyTextBox {
  border: 1px solid var(--Divider);
  margin-left: -56px;
}

html[dir="rtl"] .replyTextBox {
  margin-right: -56px;

}

.d-none {
  display: none;
}

#comment_textarea:focus {
  color: var(--HeadlineBlack) !important;
}

.dkcontainer:focus-within .sendMessageBtn i {
  background-color: var(--IconActive);
  /* color: var(--IconActive); */
}

.dkcontainer:focus-within .sendUploadBtn {
  color: var(--IconActive);
}

.fixed-width {
  max-width: 240px;
}

.mention-text-area {
  white-space: nowrap;
  height: 20px;
  display: inline-block;
  margin-top: 12px;
  padding: 0px 4px 6px;
  border-radius: 4px;
}

html[dir="rtl"] .mention-text-area {
  display: flex;
  align-items: center;
}

.more-btn-parent-div {
  position: absolute;
}

.community-detail .video-js {
  height: auto !important;
  right: 0 !important;
}

.community-detail .video-js video {
  position: relative !important;
}

.header-toggle .mdc-list-item, .toggle-menu .mdc-list-item {
    padding: 15px 24px;
}

.action-modal {
  opacity: 1;
  min-width: 160px !important;
}

.modal-background{
  background: rgba(0, 0, 0, 0.01);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>

<style lang="css" scoped src="../../css/bootstrap.css"></style>
<style lang="css" scoped src="../../css/editor.css"></style>
